enum ContentType {
  TOOLBOX_PDF_CONTENT = "toolbox_pdf_content",
  SUGGESTED_GOAL = "suggested_goal",
  KIT_TYPE = "kit_type",
}

export default ContentType;
